import React from 'react';

import '../styles/card.css';

export default function CardGroup({ children }: React.PropsWithChildren) {
  return (
    <div className="card-group">
      {children}
    </div>
  );
}
